import { NotificationsTranslation } from '@/assets/locales/views/notifications/notifications.translation.en.ts';

export const notificationsTranslation: NotificationsTranslation = {
  content: {
    actions: {
      back: 'Wróć na Start',
      markAllAsRead: 'Oznacz wszystkie jako przeczytane',
    },
    filtersTitle: 'Filtry',
    noNotifications: {
      description: 'Brak powiadomień pasujących do Twoich kryteriów.',
      title: 'Brak powiadomień',
    },
    pagination: {
      next: 'Następne',
      previous: 'Poprzednie',
      summary: 'Strona {{current}} z {{total}} · {{count}} powiadomień',
    },
    title: 'Wszystkie Powiadomienia',
  },
  form: {
    actions: {
      reset: 'Resetuj',
      submit: 'Szukaj',
    },
    filters: {
      createdAfter: 'Utworzone po',
      createdBefore: 'Utworzone przed',
      createdByMe: 'Pokaż powiadomienia utworzone przeze mnie',
      forMe: 'Pokaż moje powiadomienia',
      seen: 'Status',
      seenOptions: {
        all: 'Wszystkie',
        seen: 'Przeczytane',
        unseen: 'Nieprzeczytane',
      },
      visibility: 'Widoczność',
    },
  },
  notification: {
    survey: {
      assigned: {
        content:
          'Została Ci przypisana ankieta do wypełnienia. Prosimy o wypełnienie jej do terminu.',
        title: 'Nowa ankieta przypisana',
      },
    },
  },
};
